<template>
  <div class="input-v2">
    <div v-if="type === 'password'">
      <input
        :placeholder="placeholder"
        :type="state.isPassword ? 'password' : 'text'"
        :required="required"
        @input="$emit('change', $event.target.value.trim())"
        v-if="!disabled || !showInput"
        :value="value"
        :disabled="disabled"
      />
      <div
        class="input-v2__password-icon"
        @click="state.isPassword = !state.isPassword"
      >
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.5418 10.59C10.3421 10.8111 10.1012 10.9884 9.83357 11.1113C9.56593 11.2343 9.27702 11.3005 8.98407 11.3058C8.69111 11.3111 8.40012 11.2555 8.12844 11.1424C7.85677 11.0292 7.60998 10.8608 7.4028 10.6471C7.19562 10.4335 7.03229 10.179 6.92255 9.8988C6.81282 9.61864 6.75893 9.31855 6.7641 9.01644C6.76927 8.71433 6.83339 8.41639 6.95264 8.1404C7.07189 7.8644 7.24382 7.616 7.45818 7.41001M13.32 13.455C12.0768 14.4323 10.563 14.9736 9 15C3.90909 15 1 9.00001 1 9.00001C1.90465 7.26143 3.15937 5.74247 4.68 4.54502L13.32 13.455ZM7.47273 3.18002C7.97333 3.05918 8.48586 2.99877 9 3.00002C14.0909 3.00002 17 9.00001 17 9.00001C16.5585 9.85171 16.032 10.6536 15.4291 11.3925L7.47273 3.18002Z"
            stroke="#616E7C"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M1 1L17 17"
            stroke="#616E7C"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
    </div>
    <div v-else>
      <input
        :placeholder="placeholder"
        :type="type || 'text'"
        required
        @input="$emit('change', $event.target.value.trim())"
        :class="classes"
        v-if="!disabled || showInput"
        :oninvalid="oninvalid"
        oninput="setCustomValidity('')"
        :pattern="pattern"
        :minlength="minlength"
        :maxlength="maxlength"
        :value="value"
        :disabled="disabled"
      />
    </div>

    <div v-if="disabled && !showInput" :class="classes">
      <div>
        <div class="title">{{ placeholder }}</div>
        <div class="description">{{ value }}</div>
      </div>
      <div
        class="right-text"
        v-if="!hideRightText"
        @click="handleRightTextClick"
      >
        {{ rightText }}
      </div>
    </div>
  </div>
</template>
<script>
import { reactive } from "@vue/composition-api";

export default {
  name: "InputV2",
  props: {
    placeholder: String,
    type: String,
    required: Boolean,
    onChange: Function,
    disabled: Boolean,
    classes: String,
    value: String,
    maxlength: String,
    pattern: String,
    handleRightTextClick: Function,
    rightText: String,
    oninvalid: String,
    minlength: String,
    showInput: Boolean,
    hideRightText: Boolean,
  },
  model: {
    event: "change",
  },
  setup() {
    const state = reactive({
      isPassword: true,
    });

    return {
      state,
    };
  },
};
</script>
<style lang="scss" scoped>
.input-v2 {
  position: relative;

  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  /* Firefox */
  input[type="number"] {
    -moz-appearance: textfield;
  }

  input:disabled {
    background: rgba(13, 72, 64, 0.05) !important;
    color: #000;
  }

  .right-text {
    cursor: pointer;
  }

  input {
    height: 48px;
    width: 100%;
    padding: 16px;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    color: #000;
    outline: none;
    border: 0.5px solid rgba(97, 110, 124, 0.25);
    border-radius: 4px;
  }

  &__password-icon {
    position: absolute;
    right: 16px;
    top: 20%;
    cursor: pointer;
  }
}
</style>
